/* global $ window Bugsnag */

const slugMap = {
    amvbddo   : 'amvbbdo',
    mhs       : 'mhs-2016',
    mhs2016   : 'mhs-2016',
    cowan     : 'cowan-2016',
    hilton    : 'hilton-2016',
    kingswood : 'kingswood-2016'
}

const env                       = require('../env')
const applyOrganisationBranding = require('../applyOrganisationBranding')
const applyOrganisationAssets   = require('../applyOrganisationAssets')
const {baseurl, stage}          = env

const utils = require('../utils')

let slug

if (stage === 'production') {
    slug = window.location.pathname.replace('/', '').replace(/\./g, '').replace(/\//, '.')
} else {
    slug = window.location.hash ? window.location.hash.replace('#', '').replace(/\//, '.') : ''
}

// AMV fix
if (slug && slugMap[slug]) {
    slug = slugMap[slug]
}

// HTML Overwrite
if ($('body').attr('data-slug')) {
    slug = $('body').attr('data-slug')
}

// Add slug to body for custom styles
$('body').addClass('org-' + (slug || 'generic'))

// Scroll with the discover link
$('.discover').animateAnchorScroll()

// Get creds
if (slug.length > 0) {
    $.ajax({
        method   : 'GET',
        url      : baseurl + '/credentials/lander/' + slug,
        dataType : 'json',
        success  : data => {
            if (data.success) {
                slug = data.slug

                if (data.h2) {
                    // Escape the content, and then replace Names & Faces with &nbsp; to prevent line breaks
                    const titleText = $('<div/>').text(data.h2).html()
                    .replace(/names &amp; faces/i, 'Names&nbsp;&amp;&nbsp;Faces')

                    $('#content-wrap h2').html(titleText)
                }

                $("#copy").append($('<p>').text(data.copy.join(' ')))

                applyOrganisationAssets(data)
                applyOrganisationBranding(data)
            } else {
                $("#loading-div").fadeOut(400, () => {
                    $("#four-oh-four").fadeInCss()
                })

                Bugsnag.notify("Organisation Not Found: " + slug, "Not Found Error: " + slug)
            }
        },
        error    : (jqXHR, textStatus, errorThrown) => {
            $("#loading-div").fadeOut(400, () => {
                $("#four-oh-four").fadeInCss()
            })

            Bugsnag.notifyException("OrganisationNotFound: " + textStatus + " " + slug, errorThrown)
        }
    })
} else {
    $("#loading-div").fadeOut(400, () => {
        $(".token-reset").fadeInCss()
    })
}

$('#org-lander-form').on('submit', e => {
    e.preventDefault()

    if (utils.busy) {
        return
    }

    utils.hideErrorMessage()

    if (!$("#creds-terms").is(":checked")) {
        utils.showErrorMessage("Please agree to the Names &amp; Faces User Terms and Conditions.")

        return
    }

    utils.showLoadingState()

    $.ajax({
        method      : 'POST',
        url         : baseurl + '/credentials/lander/' + slug + '/getCredentials',
        data        : JSON.stringify({
            email      : $('#email').val().toLocaleLowerCase(),
            user_terms : $("#creds-terms").is(":checked")
        }),
        dataType    : 'json',
        contentType : 'text/plain',
        success     : data => {
            if (!data || !data.success) {
                utils.hideLoadingState()
                utils.showErrorMessage(data.message || "We were unable to identify your email address. " +
                    "Might we have another email address of yours on file? " +
                    "If you don't win, please contact us on " +
                    "<a href=\"mailto:hello@namesandfaces.co\">hello@namesandfaces.co</a>"
                )
            } else {
                $("#inputs").fadeOut(() => {
                    $("#success").fadeIn(300)
                })
            }
        },
        error       : () => {
            utils.hideLoadingState()
            utils.showErrorMessage(
                "We were unable to process your request. " +
                "Please try again, but if you don't win, please contact us on " +
                "<a href=\"mailto:hello@namesandfaces.co\">hello@namesandfaces.co</a>"
            )
        }
    })
})

$("#generic-lander").on('submit', e => {
    e.preventDefault()

    if (utils.busy) {
        return
    }

    utils.hideErrorMessage()

    utils.showLoadingState()

    $.ajax({
        method      : 'POST',
        url         : baseurl + '/credentials/generic/email',
        data        : JSON.stringify({
            email : $('#generic-email').val().toLocaleLowerCase()
        }),
        dataType    : 'json',
        contentType : 'text/plain',
        success     : data => {
            if (data && data.success) {
                $("#generic-lander").fixHeight()
                $("#generic-inputs").fadeOut(() => {
                    $("#generic-success").fadeIn(300)
                })
            } else {
                utils.hideLoadingState()
                utils.showErrorMessage(data.message || "We were unable to identify your email address. " +
                    "Might we have another email address of yours on file? " +
                    "If you don't win, please contact us on " +
                    "<a href=\"mailto:hello@namesandfaces.co\">hello@namesandfaces.co</a>."
                )
            }
        },

        error : (jqXHR, textStatus, errorThrown) => {
            utils.hideLoadingState()

            if (jqXHR.responseJSON && jqXHR.responseJSON.errors && jqXHR.responseJSON.errors.length) {
                return utils.showErrorMessage(
                    jqXHR.responseJSON.errors[0].message
                )
            }

            return utils.showErrorMessage(
                "We were unable to process your request. " +
                "Please try again, but if you don't win, please contact us on " +
                "<a href=\"mailto:hello@namesandfaces.co\">hello@namesandfaces.co</a>"
            )
        }
    })
})

if (env.query.err) {
    switch (env.query.err) {
        case 'claimed':
            utils.showErrorMessage(
                "That link has already been used - please enter your email address below to be sent another. " +
                "<br>If you don't win, please contact us on " +
                "<a href=\"mailto:hello@namesandfaces.co\">hello@namesandfaces.co</a>",
                false
            )
            break
        case 'expired':
        default:
            utils.showErrorMessage(
                "That link has expired - please enter your email address below to be sent another. " +
                "<br>If you don't win, please contact us on " +
                "<a href=\"mailto:hello@namesandfaces.co\">hello@namesandfaces.co</a>",
                false
            )
            break
    }
}

module.exports = {}



/** WEBPACK FOOTER **
 ** ./js/credentials/routes/index.js
 **/